import { useEffect, useState } from 'react';
import { GroupDatas, GroupElement } from '../../models';
import { groupService } from '../../services/group.service';

export const useGroupSuggestionHook = () => {
  const [groups, setGroups] = useState<GroupDatas[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [group, setGroup] = useState<GroupElement | null>(null);

  const appendNewGroup = (newGroup: GroupElement) => {
    // setGroups((prev) => [newGroup, ...prev]);
  };

  const getGroups = async () => {
    try {
      setLoading(true);
      const res: any = await groupService.getGroupSuggestion();
      // API trả { httpCode, message, data: { elements: [...] } } → mảng nằm ở res.data.elements.
      // Phòng thủ chấp nhận mọi shape ({data:{elements}}, {data:[]}, {elements}, mảng thô) để KHÔNG
      // bao giờ `[...x]` trên non-array → tránh "not iterable" làm trắng cả trang /group.
      const list = Array.isArray(res?.data?.elements)
        ? res.data.elements
        : Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.elements)
        ? res.elements
        : Array.isArray(res)
        ? res
        : [];
      setGroups((prev) => [...prev, ...list]);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGroups();
  }, []);

  return {
    data: groups,
    loading,
    detail: group,
    appendNewGroup,
  };
};
